import BaseView from './abstract/SVG';
import AnalyticsDecorate from '../../../../analytics/decorate';

module.exports = AnalyticsDecorate(require('./analytics/text-banner'), BaseView.extend({
  setImageListeners: function () {
    const image = this.el.querySelector('img');

    image.crossOrigin = 'Anonymous';
    image.addEventListener('load', () => this.processImage(image));
  },

  getTemplateRenderData: function () {
    return {
      banner: true,
      no_opacity: true,
      image: { src: this.svg.url }
    };
  },

  processImage: function (image) {
    this.resize();
    image.parentElement.style.opacity = '1';
  }
}));
